var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":!_vm.locked,"variant":"warning"}},[_vm._v(" Diese Seite wird gerade von "+_vm._s(_vm._f("capitalize")(_vm.lockedBy))+" bearbeitet. Du kannst sie daher nicht bearbeiten! ")])}
var staticRenderFns = []

export { render, staticRenderFns }